<template>
  <div id="login">
    <div class="row w-100" style="padding-left: 20%; padding-right: 20%">
      <div class="col-12 col-sm-2 col-lg-3"></div>
      <div class="col-12 col-sm-8 col-lg-6">
        <div
          class="shadow"
          style="min-height: 50vh; border-radius: 3%; padding: 50px"
        >
          <div
            class="mb-5"
            style="display: flex; flex-direction: column; align-items: center"
          >
            <img
              src="@/assets/img/Logo/MPM_Parts_Full Colour_CMYK copy@2x.png"
              class="img-static"
              style="width: 250px"
            />
            <label class="logoSubTitle">Tracking Monitoring System</label>
          </div>

          <div class="form-group">
            <label class="labelForm">User Name </label>
            <input
              type="text"
              class="form-control"
              v-model="form.username"
              @keyup.enter="login"
            />
          </div>
          <div class="form-group mt-5">
            <label class="labelForm">Password </label>
            <input
              type="password"
              class="form-control"
              v-model="form.password"
              @keyup.enter="login"
            />
          </div>
          <div class="form-group mt-5">
            <label class="labelForm">Ekspedisi </label>
            <input
              type="text"
              class="form-control"
              v-model="form.ekspedisi"
              @keyup.enter="login"
            />
          </div>

          <div class="form-group text-center mt-5">
            <button class="btn ahmoil-button" type="button" @click="login">
              Login
            </button>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-2 col-lg-3"></div>
    </div>

    <div class="footerLogin">&copy; 2023 MPM, All Rights Reserved</div>
  </div>
</template>

<script type="text/javascript">
export default {
  metaInfo: {
    title: "Login",
    titleTemplate: "MPM Tracking Monitoring System Dashboard - %s",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
  name: "Login",
  data() {
    return {
      form: {
        username: "",
        password: "",
        ekspedisi: "",
      },
      call: 0,
      error: false,
      mobile: this.isMobile(),
    };
  },
  mounted() {},
  watch: {
    "form.ekspedisi"() {
      this.form.ekspedisi = this.form.ekspedisi.toUpperCase();
    },
  },
  methods: {
    login: function () {
      const requestBody = {
        username: this.form.username,
        password: this.form.password
      };

      this.$http(`/api/auth/check-user?username=${this.form.username}`)
        .then((resp) => {
          if (
            resp.data.data.type === "ADMIN_EKSPEDISI" &&
            this.form.ekspedisi === ""
          ) {
            this.$swal.fire({
              title: "Error!",
              icon: "error",
              type: "error",
              text: `"ekspedisi" is not allowed to be empty`,
            });
            return;
          }

          if (resp.data.data.type === "ADMIN_EKSPEDISI" && this.form.ekspedisi !== "") {
            requestBody.ekspedisi = this.form.ekspedisi;
          }

          this.loginUser(requestBody);
        })
        .catch((err) => {
          this.$swal.fire({
            title: "Error!",
            icon: "error",
            type: "error",
            text: err.response.data.message,
          });
        });

      // this.$store.dispatch('setUser', {
      //   user_id: 2,
      //   username: 'andre',
      //   fullname: 'Andre',
      //   role: 'ADMINISTRATOR',
      // });
      // this.$router.push({name : 'Highlight'});
    },

    loginUser: function (requestBody) {
      this.$http
        .post("/api/auth/login", requestBody)
        .then(async (resp) => {
          var user = resp.data.data;

          this.$http.defaults.headers.common["Authorization"] = `Bearer ${user.token}`;
          user.name = this.form.username;

          this.$store.dispatch("setUser", user);
          // this.$store.dispatch('setCompanyDetails', companyDetails);

          // After successful login, determine which route to navigate to based on the username
          if (user.type === "ADMIN_EKSPEDISI") {
            this.$router.push({ name: "PlanAlokasi" });
          } else {
            this.$router.push({ name: "PlanAlokasiMuat" });
          }
          await this.loadFilterOptions();
        })
        .catch((err) => {
          this.$swal.fire({
            title: "Error!",
            icon: "error",
            type: "error",
            text: err.response.data.message,
          });
        });
    }
  },
};
</script>

<style scoped>
#login {
  height: 100vh;
  background: #f8f8f8;
  /* background : url('~@/assets/img/Logo/background2.png')no-repeat center center fixed;  */
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: 100% auto;
  position: relative;
  overflow-y: hidden;

  display: flex;
  flex-direction: column;
  justify-content: center;
}

.shadow {
  background: #fff;
  /* height: 10px; */
}

.h-10 {
  height: 10% !important;
}

.toCenter {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.wid50 {
  width: 50vw;
}

.wid90 {
  width: 90vw;
}

#loginShade {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  height: 400px;

  margin: 0 auto;

  background-color: #000;
  opacity: 0.5;
  border-radius: 7px;
}

#loginBox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  height: 400px;

  margin: 0 auto;
  padding: 2%;
  color: white;
}

.login-input {
  height: 50px;
}

.login-input::placeholder {
  font-size: 130%;
  font-weight: bold;
}

.labelForm {
  font-size: 15px;
  font-weight: 600;
  color: #575757;
}

.form-control {
  border: 0;
  outline: 0;
  border-bottom: 2px solid #ddd;
  border-radius: 0;
  padding: 0;
  font-size: 1rem;
}

.form-control:focus {
  border: 0 !important;
  outline: 0 !important;
  box-shadow: 0 1px 1px #fff inset;
  border-bottom: 2px solid #1f6dbb !important;
  border-radius: 0;
  transition: all 0.7s ease;
}

.footerLogin {
  position: fixed;
  left: 50%;
  bottom: 20px;
  transform: translate(-50%, -50%);
  margin: 0 auto;
  color: grey;
  font-size: 11px;
}

.ahmoil-button {
  width: 100%;
  height: 40px;
  background: #f36f21;
  color: white;
  font-size: 125%;
}

.footerLogin {
  color: #4e5c68;
}

.logoSubTitle {
  font: normal normal 600 16px/25px;
  color: #1b698e;
}
</style>
